import React from 'react';
import BriefContract from './../../BriefContract/BriefContract.js';

const ContractTab = ({ project }) => {
    return (
        <div className='BriefInfoSection'>
            <BriefContract project={project} />
        </div>
    );
};

export default ContractTab;